<script setup>
/**
 * FormFieldsetAnchor
 * A navigation button used within the form sidebar.
 * Maps fieldset titles to specific icons to improve scannability.
 */
import { computed } from 'vue';
import Button from '@/common/Button.vue';

const props = defineProps({
    title: {
        type: String,
        required: true
    }
});

// --- Computed ---

/**
 * Maps the title to a Bootstrap Icon class name.
 */
const className = computed(() => {
    const icons = {
        'Access': 'bi-person',
        'Content': 'bi-body-text',
        'General': 'bi-dash',
        'Google data feed': 'bi-google',
        'Media': 'bi-image',
        'Pricing': 'bi-currency-pound',
        'Scheduling': 'bi-calendar',
        'SEO': 'bi-graph-up',
        'Settings': 'bi-gear-fill',
        'Shipping': 'bi-truck',
        'Stock': 'bi-123',
        'Tags': 'bi-tags',
    };

    return icons[props.title] || 'bi-dash';
});
</script>

<template>
    <Button :title="title" class="d-block btn-sm w-100 text-start">
        <i v-if="className" class="me-2" :class="className"/>
        {{ title }}
    </Button>
</template>